import type { Plan } from '../types/content'

export const planes: Plan[] = [
  {
    id: 'megapack',
    emoji: '📦',
    name: 'MegaPack Cocina Proteica Lista',
    includes: '6 Tomos + 6 Bonos',
    bestFor: 'Tu semana proteica resuelta de una vez',
    listPrice: '$58.000 ARS',
    price: '$19.990 ARS',
    features: [
      '6 Tomos completos (200+ páginas)',
      '6 Bonos estratégicos ($94.000 de valor) gratis',
      'Checklists e imprimibles listos',
      'Listas de compras semanales incluidas',
      'Acceso inmediato en PDF',
      'Sistema diseñado 100% para Argentina',
    ],
    cta: 'Quiero mi MegaPack',
    checkoutUrl: 'https://www.recursoclosethegap.shop/cart/51903108481319:1',
    featured: false,
  },
  {
    id: 'sistema-total',
    emoji: '🏆',
    name: 'MegaPack + El Método 80/20',
    includes: '6 Tomos + 6 Bonos + El Método 80/20',
    bestFor: 'Las que quieren el sistema completo de optimización',
    listPrice: '$78.000 ARS',
    price: '$27.990 ARS',
    features: [
      'Todo lo del MegaPack Base',
      'El Método 80/20 — Optimización Metabólica & Longevidad',
      'Protocolo de absorción proteica máxima',
      'Guía de suplementación básica accesible en Argentina',
      'Plan de hidratación y rendimiento semanal',
      'Protocolo de hábitos 30 días paso a paso',
      'Manual de optimización metabólica y longevidad',
      'Acceso prioritario a actualizaciones futuras',
    ],
    cta: 'Quiero el Sistema Total',
    checkoutUrl: 'https://www.recursoclosethegap.shop/cart/51903109857575:1',
    featured: true,
  },
]
